const getShowEntityColor = _state => false; //state.definitions.relationshipViewSettings.showEntityColor;

export default { getShowEntityColor };
